// Select all seats using "⌘+A" or "Ctrl+A"
const SelectAll = {
  order: Infinity,
  run($$) {
    const A_KEY_CODE = 65;
    const seatClickHandler = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.keyCode === A_KEY_CODE)) {
        e.preventDefault();
        Object.keys($$.seats)
          .filter(function (seatId) {
            const seat = $$.seats[seatId];
            // const seatStatus = seat.status || "taken";
            return !seat.selected;
          })
          .forEach(function (seatId) {
            const seat = $$.seats[seatId];
            seat.selected = true;
            seat.el.attr("data-selected", true);
            setTimeout((() => $$.$arena.trigger("seat:select", [
              [seat]
            ])), 0);
          });
      }
    };

    $$.$.parent().attr("tabindex", 0);
    $$.$.on("mousedown", () => $$.$.parent().focus());
    $$.$.parent().on("keydown", seatClickHandler);
  },
};

window.SectionSelectAll = SelectAll;

export default SelectAll;
